<div class="tab-pane">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <mat-tab-group (selectedTabChange)="tabChanged($event)" animationDuration="0ms">
    <mat-tab label="Manage Regulators">
      <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
      <div class="mt-2">
        <div class="row mt-3 margin-lr-0">
          <div class="col-lg-3" *ngIf="jurisdictions.length > 0">
            <label class="control-label fw">Division</label>
            <select class="form-control form-control-sm" [(ngModel)]="selectedJurisId"
              (change)="fetchJurisdictionsRegulator()">
              <option *ngFor="let juris of jurisdictions" value="{{juris.id}}">{{juris.name}}</option>
            </select>
          </div>
          <div class="col-lg-3">
            <label class="control-label fw">Search Regulator</label>
            <form class="form-inline d-flex md-form form-sm">
              <input class="form-control form-control-sm mr-3 w-75" (keyup)="onEnterKeySearch($event)"
                [(ngModel)]="searchRegText" type="text" placeholder="Search" name="search" aria-label="Search" />
              <i class="fa fa-search search-icon cursor-pointer" (click)="searchRegulator()" aria-hidden="true"></i>
            </form>
          </div>
        </div>
        <div
          class="mt-4 px-3 manage_publication_dataHeading d-flex align-items-center justify-content-between flex-wrap">
          <span>Select the Regulators that you want:</span>
          <div>
            <span style="margin-right: 7px; margin-top: 4px;" class="text-blue pl-3" (click)="downloadUserRegulator()"
              *ngIf="commonService.checkPlanTypeAction('SSE')">
              <span class="fa fa-download"></span> Export Report
              <i *ngIf="isExportLoader" class="fa fa-circle-o-notch fa-spin"
                style="font-size: .875rem; line-height: 1.5;"></i>
            </span>
            <button class="btn btn-sm bg-g-lightGreen" (click)="saveJurisdictionRegulator()">Update
              <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin"
                style="font-size: .875rem; line-height: 1.5;"></i>
            </button>
          </div>
        </div>
        <div class="overflow-x mt-2 table-height position-relative">
          <table class="table table-curved publications_table table-striped table-hover table-bordered">
            <thead class="box-shadow-none">
              <tr>
                <th>Geography</th>
                <th>Country</th>
                <th>Regulator</th>
                <th>Publication Types</th>
                <th class="text-center">
                  <!-- <mat-slide-toggle *ngIf="regulators.length === regulatorArray.length" checked -->
                  <mat-slide-toggle *ngIf="regulatorArray.length === regulators.length" checked
                    (change)="selectAllItem($event.checked)">
                  </mat-slide-toggle>
                  <mat-slide-toggle *ngIf="regulators.length !== regulatorArray.length"
                    (change)="selectAllItem($event.checked)">
                  </mat-slide-toggle>
                </th>
              </tr>
            </thead>
            <tbody class="table-body">
              <ng-container *ngFor="let item of regulators">
                <tr>
                  <td>{{ item.geography }}</td>
                  <td>{{ item.country }}</td>
                  <td pTooltip="{{item.description}}" tooltipPosition="right">{{ item.regulatorAcr }}</td>
                  <td>
                    <div class="custom_tags_div">
                      <span *ngFor="let publication of item.metaData|jsonPubstringToArray" class="custom_tag">
                        <span class="mr-1">{{ publication.PubType }}</span>
                      </span>
                    </div>
                  </td>
                  <td class="text-center">
                    <mat-slide-toggle [checked]="checkJurisRegulator(item.id)"
                      (change)="selectRegulators(item.id, $event.checked)">
                    </mat-slide-toggle>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div class="mt-3">
          <button class="btn btn-sm bg-g-lightGreen pull-right" (click)="saveJurisdictionRegulator()">Update
            <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin" style="font-size: .875rem; line-height: 1.5;"></i>
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Manage Pub Type">
      <app-progress-bar [isLoading]="isLoadingBar"></app-progress-bar>
      <div class="br-none mt-3">
        <div class="row margin-lr-0">
          <div class="col-lg-3">
            <label class="control-label fw">Division</label>
            <select class="form-control form-control-sm" [(ngModel)]="selectedJurisIdForPubType"
              (change)="fetchJurisRegulator()">
              <option *ngFor="let juris of jurisdictions" value="{{juris.id}}">{{juris.name}}</option>
            </select>
          </div>
          <div class="col-lg-3">

            <!-- <mat-form-field class="example-full-width" appearance="fill"> -->
            <!-- <label class="control-label fw">Regulator</label>
              <input type="text" placeholder="Pick one" aria-label="Number" [formControl]="regulatorAutocomplete" matInput
              [matAutocomplete]="auto">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option *ngFor="let option of jurisRegulator " [value]="option.itemId">
                  {{option.itemTitle}}
                </mat-option>
              </mat-autocomplete> -->
            <!-- </mat-form-field> -->


            <!-- regulator search -->
            <div class="form-group">
              <label class="control-label fw">Regulator</label>
              <!-- <input class="form-control form-control-sm mat-autodd-input border-bottom" #countryInput
                [formControl]="regulatorAutocompleteCntrl" [matAutocomplete]="regulatorAutoComplete">
              <mat-autocomplete #regulatorAutoComplete="matAutocomplete" [displayWith]="regulatorDisplayFn.bind(this)"
                (optionSelected)="regulatorAutoSelect($event)">
                <mat-option *ngFor="let item of searchedRegulators" [value]="item.itemId" [title]="item.itemTitle">
                  {{item.itemTitle}}
                </mat-option>
              </mat-autocomplete> -->
              <input class="form-control form-control-sm mat-autodd-input border-bottom" #input type="text" placeholder="Pick one" matInput [(ngModel)]="searchRegulatorId"
                [matAutocomplete]="regulatorAutoComplete" (input)="regulatorFilter()" (focus)="regulatorFilter()" (change)="regulatorFilter()">
              <mat-autocomplete requireSelection #regulatorAutoComplete="matAutocomplete" [displayWith]="regulatorDisplayFn.bind(this)" (optionSelected)="regulatorAutoSelect($event)">
                <mat-option *ngFor="let item of searchedRegulators" [value]="item.itemId" [title]="item.itemTitle">
                  {{item.itemTitle}}
                </mat-option>
              </mat-autocomplete>
            </div>

            <!-- <select class="form-control form-control-sm" (change)="fetchPubTypes()" [(ngModel)]="searchRegulatorId">
              <option *ngFor="let item of jurisRegulator" value="{{ item.itemId }}">
                {{ item.itemTitle }}
              </option>
            </select> -->
          </div>
          <div class="col-lg-3">
            <label class="control-label fw">Search Pub Type</label>
            <form class="form-inline d-flex md-form form-sm">
              <input class="form-control form-control-sm mr-3 w-75" (keyup)="onEnterPubSearch($event)"
                [(ngModel)]="searchPubText" type="text" placeholder="Search" name="search" aria-label="Search" />
              <i class="fa fa-search search-icon cursor-pointer" (click)="searchPub()" aria-hidden="true"></i>
            </form>
          </div>
        </div>
        <div
          class="mt-3 px-3 manage_publication_dataHeading d-flex align-items-center justify-content-between flex-wrap">
          <span class="fw"> Note: Switch OFF to move the publication from Open to Filtered Out tab of the Change
            Viewer.</span>
          <div>
            <span style="margin-right: 7px; margin-top: 4px;" class="text-blue pl-3" (click)="downloadUserRegulator()"
              *ngIf="commonService.checkPlanTypeAction('SSE')">
              <span class="fa fa-download"></span> Export Report
              <i *ngIf="isExportLoader" class="fa fa-circle-o-notch fa-spin"
                style="font-size: .875rem; line-height: 1.5;"></i>
            </span>
            <button class="btn btn-sm bg-g-lightGreen" (click)="updatePubType()">Update</button>
          </div>
        </div>
        <div class="overflow-x mt-1 table-responsive box-shadow" *ngIf="searchRegulatorId > 0"
          [style.max-height.px]="myInnerHeight">
          <table class="table table-sm table-curved table-hover table-bordered">
            <thead class="box-shadow-none">
              <tr>
                <th>Pub Type</th>
                <th class="text-center">
                  <mat-slide-toggle *ngIf="pubTypeList.pubType.length === getUpdatedPubTypeLen()" checked
                    (change)="selectAllPubItem($event.checked)">
                  </mat-slide-toggle>
                  <mat-slide-toggle *ngIf="pubTypeList.pubType.length > getUpdatedPubTypeLen()"
                    (change)="selectAllPubItem($event.checked)">
                  </mat-slide-toggle>
                </th>
              </tr>
            </thead>
            <tbody [style.max-height.px]="myInnerHeight">
              <tr class="parent-menu">
                <td>{{ pubTypeList.regulator }}</td>
                <td></td>
              </tr>
              <tr *ngFor="let pub of pubTypeList.pubType">
                <td class="pl-25">{{ pub.title }}</td>
                <td class="text-center">
                  <mat-slide-toggle [checked]="!pub.isActive"
                    (change)="selectPubType(pub.title, $event.checked,pub.updatesDB_Id)">
                  </mat-slide-toggle>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>